import { render, staticRenderFns } from "./BoardListView.vue?vue&type=template&id=b6e12a7e&scoped=true"
import script from "./BoardListView.vue?vue&type=script&lang=js"
export * from "./BoardListView.vue?vue&type=script&lang=js"
import style0 from "./BoardListView.vue?vue&type=style&index=0&id=b6e12a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e12a7e",
  null
  
)

export default component.exports